import { useStaticData } from '@mc/static-data-react'
import { useUserInfo } from '@mc/user-info'

export const UserState = ({
  loggedIn,
  loggedOut,
  enterpriseAdmin,
  member,
  nonMember,
  children,
}: {
  loggedIn?: boolean
  loggedOut?: boolean
  enterpriseAdmin?: boolean
  member?: boolean
  nonMember?: boolean
  children: React.ReactNode
}) => {
  const { isLoggedIn } = useStaticData<{ isLoggedIn: boolean }>()
  const { user } = useUserInfo()
  const isEnterpriseAdmin = !!user?.organizationsAdministered?.length
  const hasSubscription = !!user?.activeAnnualPass

  if (enterpriseAdmin) {
    if (isEnterpriseAdmin) {
      return <>{children}</>
    } else {
      return <></>
    }
  }
  if (hasSubscription && member) return <>{children}</>
  if (!hasSubscription && nonMember) return <>{children}</>
  if (isLoggedIn && loggedIn) return <>{children}</>
  if (!isLoggedIn && loggedOut) return <>{children}</>
  return <></>
}
